/*
 * PDP sticky Add to Cart test (docs/pdp-sticky-atc.md). Mobile only.
 * Turned on by fd-sticky-atc-v1 / fd-sticky-atc-v2 on html or body, or ?fd_sticky_atc=v1|v2.
 * V1 mirrors the buy box (quantity, frequency, Subtotal row) and clicks #PBFCM-add-to-cart-btn.
 * V2 scrolls back to the buy box. Both hide while any part of the buy box is on screen.
 */
(function () {
  if (customElements.get('fd-pdp-sticky-atc')) return;

  var VARIANTS = ['v1', 'v2'];
  var MOBILE = '(max-width: 749px)';
  var EXPERIMENT_ID = 'PDP_STICKY_ATC';

  (function applyQuery() {
    try {
      var value = (new URLSearchParams(window.location.search).get('fd_sticky_atc') || '').toLowerCase();
      if (VARIANTS.indexOf(value) !== -1) document.documentElement.classList.add('fd-sticky-atc-' + value);
    } catch (err) {
      return;
    }
  })();

  function activeVariant() {
    for (var i = 0; i < VARIANTS.length; i++) {
      var cls = 'fd-sticky-atc-' + VARIANTS[i];
      if (document.documentElement.classList.contains(cls)) return VARIANTS[i];
      if (document.body && document.body.classList.contains(cls)) return VARIANTS[i];
    }
    return '';
  }

  window.fdEnableStickyAtc = function (variant) {
    VARIANTS.forEach(function (v) {
      document.documentElement.classList.remove('fd-sticky-atc-' + v);
      if (document.body) document.body.classList.remove('fd-sticky-atc-' + v);
    });
    if (VARIANTS.indexOf(variant) !== -1) document.documentElement.classList.add('fd-sticky-atc-' + variant);
  };

  function moneyParts(el) {
    if (!el) return null;
    var visible = el.querySelector('[aria-hidden="true"]');
    var text = (visible || el).textContent || '';
    var matches = text.match(/[^\d\s.,]*\s?\d[\d,]*(?:\.\d{1,2})?/g);
    if (!matches) return null;
    var raw = matches[matches.length - 1].trim();
    var number = raw.match(/\d[\d,]*(?:\.\d{1,2})?/)[0];
    var cents = Math.round(parseFloat(number.replace(/,/g, '')) * 100);
    if (!isFinite(cents)) return null;
    return { prefix: raw.slice(0, raw.indexOf(number)), cents: cents };
  }

  function formatMoney(prefix, cents) {
    var value = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (prefix || '$') + value;
  }

  function track(target, variant, handle) {
    var params = {
      experiment_id: EXPERIMENT_ID,
      variant: variant,
      target: target,
      product_handle: handle,
      page_path: window.location.pathname
    };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'pdp_sticky_atc_click' }, params));
      if (typeof window.clarity === 'function') window.clarity('event', 'pdp_sticky_atc_' + variant + '_' + target);
    } catch (err) {
      return;
    }
  }

  class FdPdpStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      var first = document.querySelector('fd-pdp-sticky-atc');
      if (first !== this) return;
      this._bound = true;
      this.variant = '';
      this.boxInView = false;
      this.hold = false;
      this.inView = new Set();
      this.mq = window.matchMedia(MOBILE);
      this.live = this.querySelector('[data-fd-sticky-live]');
      this.refresh = this.refresh.bind(this);
      this.scheduleRender = this.scheduleRender.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.onSummary = this.onSummary.bind(this);

      this.addEventListener('click', this.onClick);
      this.classObserver = new MutationObserver(this.refresh);
      this.classObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      if (document.body) this.classObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.refresh);
      this.refresh();
    }

    disconnectedCallback() {
      if (!this._bound) return;
      this._bound = false;
      this.deactivate();
      this.removeEventListener('click', this.onClick);
      if (this.classObserver) this.classObserver.disconnect();
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.refresh);
    }

    refresh() {
      var variant = this.mq.matches && document.getElementById('product-purchase-content') ? activeVariant() : '';
      if (variant === this.variant) return;
      if (this.variant) this.deactivate();
      if (variant) this.activate(variant);
    }

    loadCss() {
      var href = this.dataset.css;
      if (!href) return Promise.resolve();
      var link = document.querySelector('link[data-fd-sticky-atc-css]');
      if (link && link.sheet) return Promise.resolve();
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute('data-fd-sticky-atc-css', '');
        document.head.appendChild(link);
      }
      return new Promise(function (resolve) {
        link.addEventListener('load', resolve, { once: true });
        link.addEventListener('error', resolve, { once: true });
      });
    }

    activate(variant) {
      var self = this;
      this.variant = variant;
      this.loadCss().then(function () {
        if (self.variant !== variant) return;
        self.querySelectorAll('[data-fd-sticky-bar]').forEach(function (bar) {
          bar.hidden = bar.getAttribute('data-fd-sticky-bar') !== variant;
        });
        self.dataset.variant = variant;
        self.dataset.state = 'hidden';
        self.inert = true;
        self.hidden = false;
        self.setAttribute('data-active', '');
        document.documentElement.classList.add('fd-sticky-atc-on');
        self.observeBox();
        if (variant === 'v1') self.watchSelection();
        self.render();
        self.syncHeight();
        if (typeof window.clarity === 'function') window.clarity('set', 'pdp_sticky_atc', variant);
      });
    }

    deactivate() {
      this.variant = '';
      this.hidden = true;
      this.removeAttribute('data-active');
      delete this.dataset.variant;
      document.documentElement.classList.remove('fd-sticky-atc-on');
      document.documentElement.style.removeProperty('--fd-sticky-atc-height');
      if (this.io) this.io.disconnect();
      if (this.priceObserver) this.priceObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      document.removeEventListener('pbfcmpdp:summary-updated', this.onSummary);
      document.removeEventListener('change', this.scheduleRender);
      document.removeEventListener('cart:updated', this.onCartUpdated);
      this.inView.clear();
    }

    boxTargets() {
      return [document.getElementById('product-purchase-content'), document.getElementById('PBFCM-add-to-cart-btn')].filter(Boolean);
    }

    observeBox() {
      var self = this;
      if (this.io) this.io.disconnect();
      this.inView.clear();
      this.observed = this.boxTargets();
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.inView.add(entry.target);
          else self.inView.delete(entry.target);
        });
        self.boxInView = self.inView.size > 0;
        if (self.boxInView) self.hold = false;
        self.update();
      }, { threshold: 0 });
      this.observed.forEach(function (el) { self.io.observe(el); });
      document.addEventListener('pbfcmpdp:summary-updated', this.onSummary);
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    onSummary() {
      var current = this.boxTargets();
      var stale = current.length !== this.observed.length || current.some(function (el, i) { return el !== this.observed[i]; }, this);
      if (stale) this.observeBox();
      this.scheduleRender();
    }

    update() {
      var hidden = !this.variant || this.boxInView || this.hold;
      this.dataset.state = hidden ? 'hidden' : 'visible';
      this.inert = hidden;
    }

    syncHeight() {
      var self = this;
      var set = function () {
        document.documentElement.style.setProperty('--fd-sticky-atc-height', self.offsetHeight + 'px');
      };
      set();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(set);
        this.resizeObserver.observe(this);
      }
    }

    watchSelection() {
      var self = this;
      document.addEventListener('change', this.scheduleRender);
      this.priceObserver = new MutationObserver(this.scheduleRender);
      var watch = function () {
        self.priceObserver.disconnect();
        ['PBFCM-breakdown-subtotal-final', 'PBFCM-breakdown-subtotal-compare'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) self.priceObserver.observe(el, { childList: true, characterData: true, subtree: true });
        });
        var grid = document.querySelector('#product-purchase-content [role="radiogroup"]');
        if (grid) self.priceObserver.observe(grid, { attributes: true, subtree: true, attributeFilter: ['aria-checked', 'class'] });
      };
      watch();
      this.rewatch = watch;
    }

    scheduleRender() {
      var self = this;
      if (this._raf) return;
      this._raf = requestAnimationFrame(function () {
        self._raf = null;
        self.render();
      });
    }

    readSelection() {
      var box = document.getElementById('product-purchase-content');
      var qtyItem = box && (box.querySelector('.PBFCM-PDP-quantity-selector__item[aria-checked="true"]') || box.querySelector('.PBFCM-PDP-quantity-selector__item--selected'));
      var qtyInput = document.getElementById('PBFCM-selected-quantity');
      var qty = parseInt((qtyInput && qtyInput.value) || (qtyItem && qtyItem.dataset.quantity) || '1', 10);
      var qtyLabel = (qtyItem && (qtyItem.getAttribute('aria-label') || '').trim()) || qty + (qty === 1 ? ' Bottle' : ' Bottles');
      var freq = box && box.querySelector('input[name="PBFCM-frequency"]:checked');
      var freqLabelEl = freq && freq.id ? document.querySelector('label[for="' + freq.id + '"]') : null;
      var freqLabel = (freqLabelEl && freqLabelEl.textContent.trim()) || (freq && freq.value === 'onetime' ? 'One-Time' : 'Monthly');
      return {
        selection: qtyLabel + ' · ' + freqLabel,
        now: moneyParts(document.getElementById('PBFCM-breakdown-subtotal-final')),
        was: moneyParts(document.getElementById('PBFCM-breakdown-subtotal-compare'))
      };
    }

    render() {
      if (this.variant !== 'v1') return;
      if (this.rewatch && !document.getElementById('PBFCM-breakdown-subtotal-final')?.isConnected) this.rewatch();
      var s = this.readSelection();
      var nowText = s.now ? formatMoney(s.now.prefix, s.now.cents) : '';
      var save = s.now && s.was ? s.was.cents - s.now.cents : 0;
      var wasText = save > 0 ? formatMoney(s.was.prefix, s.was.cents) : '';
      var saveText = save > 0 ? 'Save ' + formatMoney(s.now.prefix, save) : '';
      this.setText('[data-fd-sticky-selection]', s.selection);
      this.setText('[data-fd-sticky-now]', nowText);
      this.setText('[data-fd-sticky-was]', wasText);
      this.setText('[data-fd-sticky-save]', saveText);
      this.querySelector('[data-fd-sticky-was-wrap]').hidden = !wasText;
      this.querySelector('[data-fd-sticky-save]').hidden = !saveText;
      var label = [s.selection.replace(' · ', ', '), nowText, wasText && 'was ' + wasText, saveText].filter(Boolean).join(', ');
      this.querySelector('[data-fd-sticky-atc="edit"]').setAttribute('aria-label', label + '. Edit selection');
    }

    setText(selector, value) {
      var el = this.querySelector(selector);
      if (el && el.textContent !== value) el.textContent = value;
    }

    onClick(event) {
      var control = event.target.closest('[data-fd-sticky-atc]');
      if (!control || !this.variant) return;
      var action = control.getAttribute('data-fd-sticky-atc');
      track(action, this.variant, this.dataset.productHandle || '');
      if (action === 'add') this.addToCart();
      else this.scrollToBox(action === 'edit' ? 'quantity' : 'frequency');
    }

    scrollToBox(focusTarget) {
      var self = this;
      var box = document.getElementById('product-purchase-content');
      if (!box) return;
      var heading = box.querySelector('.PBFCM-PDP-frequency-selector__title') || box;
      this.hold = true;
      this.update();
      var header = document.querySelector('.header-wrapper-container');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var top = heading.getBoundingClientRect().top + window.scrollY - headerBottom - 12;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });

      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        window.removeEventListener('scrollend', finish);
        var target = focusTarget === 'quantity'
          ? box.querySelector('.PBFCM-PDP-quantity-selector__item[aria-checked="true"]') || box.querySelector('.PBFCM-PDP-quantity-selector__item--selected')
          : box.querySelector('input[name="PBFCM-frequency"]:checked');
        if (target) target.focus({ preventScroll: true });
        self.hold = false;
        self.update();
      };
      window.addEventListener('scrollend', finish);
      setTimeout(finish, reduce ? 0 : 1200);
    }

    addToCart() {
      var main = document.getElementById('PBFCM-add-to-cart-btn');
      this.pendingAdd = Date.now();
      if (main && !main.disabled) main.click();
      else if (window.PBFCM_PDP && typeof window.PBFCM_PDP.handleAddToCart === 'function') window.PBFCM_PDP.handleAddToCart();
    }

    onCartUpdated() {
      if (!this.pendingAdd || Date.now() - this.pendingAdd > 60000) return;
      this.pendingAdd = 0;
      var btn = this.querySelector('[data-fd-sticky-atc="add"]');
      var label = btn.querySelector('[data-fd-sticky-add-label]');
      var cart = btn.querySelector('[data-fd-sticky-icon="cart"]');
      var tick = btn.querySelector('[data-fd-sticky-icon="tick"]');
      var s = this.readSelection();
      btn.setAttribute('data-added', '');
      cart.hidden = true;
      tick.hidden = false;
      label.textContent = 'Added';
      if (this.live) this.live.textContent = 'Added ' + s.selection.replace(' · ', ', ') + ' to cart.';
      clearTimeout(this._addedTimer);
      this._addedTimer = setTimeout(function () {
        btn.removeAttribute('data-added');
        cart.hidden = false;
        tick.hidden = true;
        label.textContent = 'Add To Cart';
      }, 2500);
    }
  }

  customElements.define('fd-pdp-sticky-atc', FdPdpStickyAtc);
})();
